import React from 'react';
import { Download, Plus, X } from 'lucide-react';
import { formatTime } from '../api';

export default function SongRow({ song, index, currentSongIndex, playSong, downloadSong, addSongToPlaylist, setSelectedArtist, setActiveView, removeFromPlaylist }) {
  return (
    <div className={`song-list-item ${currentSongIndex === index ? 'active' : ''}`} onClick={() => playSong(index)}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '50px' }}>
        <img src={song.coverUrl} alt={song.title} style={{ width: '30px', height: '30px', borderRadius: '4px', objectFit: 'cover' }} />
        <span style={{ color: 'var(--text-dim)', fontSize: '12px' }}>{index + 1}</span>
      </div>
      <span style={{ fontWeight: 'bold' }}>{song.title}</span>
      <span
        style={{ cursor: 'pointer', transition: 'color 0.2s' }}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedArtist(song.artist);
          setActiveView('artist-detail');
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = 'var(--primary)'}
        onMouseLeave={(e) => e.currentTarget.style.color = 'var(--text-secondary)'}
      >
        {song.artist}
      </span>
      <span>{song.album}</span>
      <span style={{ width: '80px', color: 'var(--text-secondary)' }}>{song.duration ? formatTime(song.duration) : '--:--'}</span>
      <div style={{ textAlign: 'right', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
        <button onClick={async (e) => {
          e.stopPropagation();
          await downloadSong(song);
        }} style={{ background: 'none', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', fontSize: '16px', padding: '0' }} title="Ladda ner" aria-label={`Ladda ner ${song.title}`}><Download size={17} /></button>
        <button onClick={async (e) => {
          e.stopPropagation();
          await addSongToPlaylist(song);
        }} style={{ background: 'none', border: 'none', color: 'var(--primary)', cursor: 'pointer', fontSize: '16px', padding: '0', opacity: removeFromPlaylist ? 0 : 1 }} title="Lägg till i spellista" aria-label={`Lägg till ${song.title} i spellista`}><Plus size={18} /></button>
        {removeFromPlaylist && <button onClick={(e) => { e.stopPropagation(); removeFromPlaylist(song); }} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: '16px', padding: '0' }} title="Ta bort från spellista" aria-label={`Ta bort ${song.title} från spellista`}><X size={17} /></button>}
      </div>
    </div>
  );
}
